import { defineStore } from 'pinia'
import { reactive } from 'vue'
import type { UnfoldOrderRow, FoldOrderRow, PendingOrderRow } from '@/views/(public)/trading/types'

export const orderStore = defineStore('order', () => {
  const openPositionUnfoldRowMap = reactive<Map<string, UnfoldOrderRow>>(new Map())
  const openPositionFoldRowMap = reactive<Map<string, FoldOrderRow>>(new Map())
  const pendingPositionMap = reactive<Map<string, PendingOrderRow>>(new Map())

  const updateUnfoldOrder = (order: UnfoldOrderRow) => {
    openPositionUnfoldRowMap.set(String(order.TICKET), order)
  }

  const clearUnfoldOrderMap = () => {
    openPositionUnfoldRowMap.clear()
  }

  const updateFoldOrder = (order: FoldOrderRow) => {
    openPositionFoldRowMap.set(order.SYMBOL, order)
  }

  const clearFoldOrderMap = () => {
    openPositionFoldRowMap.clear()
  }

  const updatePendingOrder = (order: PendingOrderRow) => {
    pendingPositionMap.set(String(order.TICKET), order)
  }

  const clearPendingOrderMap = () => {
    pendingPositionMap.clear()
  }

  const reset = () => {
    openPositionUnfoldRowMap.clear()
    openPositionFoldRowMap.clear()
    pendingPositionMap.clear()
  }

  return {
    openPositionUnfoldRowMap,
    openPositionFoldRowMap,
    updateFoldOrder,
    updateUnfoldOrder,
    updatePendingOrder,
    clearFoldOrderMap,
    clearUnfoldOrderMap,
    clearPendingOrderMap,
    reset,
  }
})

export default orderStore
